import { render, staticRenderFns } from "./c_home_shop.vue?vue&type=template&id=1c7819e8&scoped=true&"
import script from "./c_home_shop.vue?vue&type=script&lang=js&"
export * from "./c_home_shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7819e8",
  null
  
)

export default component.exports